<template>
  <div class="c-list-guests-tab">
    <div class="tabs is-large">
      <ul>
        <li
          :class="{
            'is-active': tabIndex === 0,
            'is-disabled no-click': tabIndex === 0 || rsvpAmountAllTotal === 0,
          }"
        >
          <a
            @click="setTabIndex(0)"
            class="has-text-weight-bold is-flex is-size-5-tablet"
            >Todos os convidados ({{ rsvpAmountAllTotal }})</a
          >
        </li>
        <li
          :class="{
            'is-active': tabIndex === 1,
            'is-disabled no-click':
              tabIndex === 1 || rsvpAmountConfirmedTotal === 0,
          }"
        >
          <a
            @click="setTabIndex(1)"
            class="has-text-weight-bold is-flex is-size-5-tablet"
            >Confirmados ({{ rsvpAmountConfirmedTotal }})</a
          >
        </li>
        <li
          :class="{
            'is-active': tabIndex === 2,
            'is-disabled no-click':
              tabIndex === 2 || rsvpAmountCancelledTotal === 0,
          }"
        >
          <a
            @click="setTabIndex(2)"
            class="has-text-weight-bold is-flex is-size-5-tablet"
            >Cancelados ({{ rsvpAmountCancelledTotal }})</a
          >
        </li>
        <li
          :class="{
            'is-active': tabIndex === 3,
            'is-disabled no-click':
              tabIndex === 3 || rsvpAmountMaybeTotal === 0,
          }"
        >
          <a
            @click="setTabIndex(3)"
            class="has-text-weight-bold is-flex is-size-5-tablet"
            >Pendentes ({{ rsvpAmountMaybeTotal }})</a
          >
        </li>
      </ul>
    </div>
    <div class="is-hidden-mobile c-list-guests-tab__header" v-if="showHeader">
      <div class="columns is-gapless is-vcentered">
        <div class="column is-3">
          <div class="c-list-guests-tab__header-label">
            <strong class="is-uppercase"> Nomes </strong>
          </div>
        </div>
        <div class="column">
          <div class="c-list-guests-tab__header-label">
            <strong class="is-uppercase"> Qtd. de convidados </strong>
          </div>
        </div>
        <div class="column is-3">
          <div class="c-list-guests-tab__header-label">
            <strong class="is-uppercase"> Contato </strong>
          </div>
        </div>
        <div class="column is-2">
          <div class="c-list-guests-tab__header-label">
            <strong class="is-uppercase"> Confirmou em </strong>
          </div>
        </div>
        <div class="column is-1"></div>
        <div class="column is-1"></div>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <div v-if="tabIndex === 0">
        <div
          v-if="rsvpConfigs?.mode === 'closed' && rsvpListAll.length == 0"
          class="has-text-centered"
        >
          <p class="has-text-centered c-list-guests-tab__no-result">
            Sua lista de presença não possui nenhum convidado cadastrado.<br />
            Que tal adicionar alguns agora?<br />
            <router-link
              :to="{ path: `/rsvp/cadastrar-convites` }"
              class="button is-neutral-outlined button-create-invites inline-flex"
            >
              <base-icon name="painel/plus-circle" />
              Cadastrar convites
            </router-link>
          </p>
        </div>
        <p
          v-else-if="rsvpListAll.length == 0"
          class="has-text-centered c-list-guests-tab__no-result"
        >
          Você ainda não possui nenhuma confirmação de presença.<br />
          Compartilhe o seu site com seus convidados 😉
        </p>

        <transition-group key="all" v-else>
          <Guests
            v-for="(rsvp, index) in rsvpListAllFiltered"
            :key="'all-' + index"
            :rsvp="rsvp"
          />
        </transition-group>
      </div>
      <div v-else-if="tabIndex === 1">
        <p
          v-if="rsvpListConfirmedFiltered.length == 0"
          class="has-text-centered c-list-guests-tab__no-result"
        >
          Você ainda não possui nenhuma confirmação de presença.<br />
          Compartilhe o seu site com seus convidados 😉
        </p>

        <transition-group key="confirmed" v-else>
          <Guests
            v-for="(rsvp, index) in rsvpListConfirmedFiltered"
            :key="'confirmed-' + index"
            :rsvp="rsvp"
          />
        </transition-group>
      </div>
      <div v-else-if="tabIndex === 2" key="cancelled">
        <transition-group>
          <Guests
            v-for="(rsvp, index) in rsvpListCancelledFiltered"
            :key="'cancelled-' + index"
            :rsvp="rsvp"
          />
        </transition-group>
      </div>
      <div v-else-if="tabIndex === 3" key="maybe">
        <transition-group>
          <Guests
            v-for="(rsvp, index) in rsvpListMaybeFiltered"
            :key="'maybe-' + index"
            :rsvp="rsvp"
          />
        </transition-group>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Guests from '@/components/Rsvp/Guests.vue'

export default {
  props: {
    search: {
      type: String,
    },
  },

  components: {
    Guests,
  },

  computed: {
    ...mapGetters({
      rsvpAmountAllTotal: 'rsvpAmountAllTotal',
      rsvpAmountConfirmedTotal: 'rsvpAmountConfirmedTotal',
      rsvpAmountCancelledTotal: 'rsvpAmountCancelledTotal',
      rsvpAmountMaybeTotal: 'rsvpAmountMaybeTotal',
      rsvpListAll: 'rsvpListAll',
      rsvpListConfirmed: 'rsvpListConfirmed',
      rsvpListCancelled: 'rsvpListCancelled',
      rsvpListMaybe: 'rsvpListMaybe',
      rsvpConfigs: 'getRsvpConfigs',
    }),
    showHeader() {
      return this.rsvpAmountAllTotal > 0
    },

    rsvpListAllFiltered() {
      return this.rsvpListAll.filter((rsvp) => {
        let searched = []
        if (rsvp.guests.length)
          searched = rsvp.guests.find((guest) =>
            this.filterByLowercase(guest.name, this.search)
          )
        return searched && !rsvp.excluded
      })
    },

    rsvpListConfirmedFiltered() {
      return this.rsvpListConfirmed.filter((rsvp) => {
        let searched = []
        if (rsvp.guests.length)
          searched = rsvp.guests.find((guest) =>
            this.filterByLowercase(guest.name, this.search)
          )
        return searched && !rsvp.excluded
      })
    },

    rsvpListCancelledFiltered() {
      return this.rsvpListCancelled.filter((rsvp) => {
        let searched = []
        if (rsvp.guests.length)
          searched = rsvp.guests.find((guest) =>
            this.filterByLowercase(guest.name, this.search)
          )
        return searched && !rsvp.excluded
      })
    },

    rsvpListMaybeFiltered() {
      return this.rsvpListMaybe.filter((rsvp) => {
        let searched = []
        if (rsvp.guests.length)
          searched = rsvp.guests.find((guest) =>
            this.filterByLowercase(guest.name, this.search)
          )
        return searched && !rsvp.excluded
      })
    },
  },

  data() {
    return {
      tabIndex: 0,
    }
  },

  methods: {
    setTabIndex(index) {
      this.tabIndex = index
    },

    filterByLowercase(string, search) {
      const stringLowerCase = string.toLowerCase()
      const searchLowerCase = search.toLowerCase()
      return stringLowerCase.includes(searchLowerCase)
    },
  },
}
</script>

<style lang="scss">
.c-list-guests-tab {
  padding: 0 0 2em;
  border-radius: 8px;
  border: 1px solid $gray-3;
  background-color: $white;

  .button-create-invites {
    margin-top: 32px;
    .svg-icon {
      margin-right: 4px;
    }
  }

  .tabs {
    scrollbar-width: none;
    > ul {
      border-bottom: solid 2px $gray-3;
    }

    li {
      width: 50%;
      @media (min-width: $tablet) {
        width: auto;
      }
    }

    li a {
      padding: 1em;
      color: $neutrallight;
      font-size: 14px;
      border-bottom-width: 2px;
      border-bottom-color: transparent;
      &:hover,
      &:focus {
        color: $gray-5;
        border-bottom-color: $gray-5;
      }
      @media (min-width: $tablet) {
        padding: 1em 3em;
      }
    }

    li.is-disabled a {
      color: $neutrallight;
      border-bottom-color: $neutrallight;
    }
    li.no-click a {
      pointer-events: none;
    }
    li.is-active a {
      color: $primary;
      border-bottom-color: $primary;
    }
  }

  &__header {
    padding: 0.5em 2em;
    margin: 0 0 1em;

    > .columns {
      border-bottom: 1px solid $gray-3;
    }
  }

  &__header-label {
    padding: 0 0.5em 0.5em 0;
    font-size: 13px;
    color: $neutrallight;
    strong {
      color: $neutrallight;
    }
  }

  &__no-result {
    color: $neutral;
    margin: 90px 5px;
  }
}
</style>
